// Shared panel shell for the overview columns (mock s4 ".card.panel"):
// compact header row (title + trailing caption/label) + body, wrapped in the
// page-wide TabCard surface primitive — white card floating on the grey tab
// surface on desktop, flat divider-separated section on mobile (no chrome).
import { Stack, Typography } from "@material-ui/core";
import { TabCard } from "../../TabCard";
import type { ReactNode } from "react";
import type { SxProps } from "@material-ui/system";
import type { Theme } from "@material-ui/core/styles";

type OverviewPanelProps = {
  title: ReactNode;
  /** Trailing element on the header row (caption / Label chip). */
  headerEnd?: ReactNode;
  children: ReactNode;
  /** Per-card overrides forwarded to TabCard (e.g. the AI card's tint). */
  sx?: SxProps<Theme>;
};

export function OverviewPanel({ title, headerEnd, children, sx }: OverviewPanelProps): JSX.Element {
  return (
    <TabCard sx={sx}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 1.5, gap: 1 }}
      >
        <Typography variant="subtitle1">{title}</Typography>
        {headerEnd}
      </Stack>
      {children}
    </TabCard>
  );
}
